import { autofill } from "@mm/weather-parameter-utils";
import { enumValues } from "../utility/enum";
/**
 * A list of all transfer functions supported by the backend.
 */
export var ColorMap;
(function (ColorMap) {
    ColorMap["air_quality_index"] = "air_quality_index";
    ColorMap["anomaly_temperature"] = "anomaly_temperature";
    ColorMap["binary_warning_segmented"] = "binary_warning_segmented";
    ColorMap["blue_magenta"] = "blue_magenta";
    ColorMap["blue_to_red"] = "blue_to_red";
    ColorMap["blues"] = "blues";
    ColorMap["blues_inverted"] = "blues_inverted";
    ColorMap["cape"] = "cape";
    ColorMap["ceiling_height_airmet"] = "ceiling_height_airmet";
    ColorMap["ceiling_height_segmented"] = "ceiling_height_segmented";
    ColorMap["cin_segmented"] = "cin_segmented";
    ColorMap["cloud_type"] = "cloud_type";
    ColorMap["convective_categories"] = "convective_categories";
    ColorMap["dust_concentration"] = "dust_concentration";
    ColorMap["dust_density"] = "dust_density";
    ColorMap["dwd_radar_5min"] = "dwd_radar_5min";
    ColorMap["dwd_warnings"] = "dwd_warnings";
    ColorMap["edr_turbulence"] = "edr_turbulence";
    ColorMap["fresh_snow_long_interval"] = "fresh_snow_long_interval";
    ColorMap["fresh_snow_short_interval"] = "fresh_snow_short_interval";
    ColorMap["gray"] = "gray";
    ColorMap["gray_inverted"] = "gray_inverted";
    ColorMap["gray_transparent"] = "gray_transparent";
    ColorMap["gray_transparent_dark"] = "gray_transparent_dark";
    ColorMap["greens_shifted"] = "greens_shifted";
    ColorMap["heavy_rain_warning_europe_segmented"] = "heavy_rain_warning_europe_segmented";
    ColorMap["incessant_rain_warning_europe_segmented"] = "incessant_rain_warning_europe_segmented";
    ColorMap["jet"] = "jet";
    ColorMap["jet_inverted"] = "jet_inverted";
    ColorMap["jet_segmented"] = "jet_segmented";
    ColorMap["jet_segmented_inverted"] = "jet_segmented_inverted";
    ColorMap["jetstream"] = "jetstream";
    ColorMap["land_usage"] = "land_usage";
    ColorMap["lifted_index_global"] = "lifted_index_global";
    ColorMap["lifted_index_global_segmented"] = "lifted_index_global_segmented";
    ColorMap["lightning_europe_transparent"] = "lightning_europe_transparent";
    ColorMap["magenta_blue"] = "magenta_blue";
    ColorMap["msg_h03b"] = "msg_h03b";
    ColorMap["negative_cold_index_segmented"] = "negative_cold_index_segmented";
    ColorMap["negative_index_segmented"] = "negative_index_segmented";
    ColorMap["periodic"] = "periodic";
    ColorMap["periodic_inverted"] = "periodic_inverted";
    ColorMap["plasma"] = "plasma";
    ColorMap["plasma_inverted"] = "plasma_inverted";
    ColorMap["pollen_europe_segmented"] = "pollen_europe_segmented";
    ColorMap["pollen_grains_large"] = "pollen_grains_large";
    ColorMap["pollen_grains_medium"] = "pollen_grains_medium";
    ColorMap["pollen_grains_small"] = "pollen_grains_small";
    ColorMap["pollen_segmented"] = "pollen_segmented";
    ColorMap["positive_index_segmented"] = "positive_index_segmented";
    ColorMap["precip_europe_segmented"] = "precip_europe_segmented";
    ColorMap["precip_layer_europe_segmented"] = "precip_layer_europe_segmented";
    ColorMap["precip_layer_segmented"] = "precip_layer_segmented";
    ColorMap["precip_segmented"] = "precip_segmented";
    ColorMap["precip_type_europe_segmented"] = "precip_type_europe_segmented";
    ColorMap["precip_type_intensity_europe_segmented"] = "precip_type_intensity_europe_segmented";
    ColorMap["precip_type_intensity_segmented"] = "precip_type_intensity_segmented";
    ColorMap["precip_type_intensity_usa_segmented"] = "precip_type_intensity_usa_segmented";
    ColorMap["precip_type_segmented"] = "precip_type_segmented";
    ColorMap["precip_usa_segmented"] = "precip_usa_segmented";
    ColorMap["prism"] = "prism";
    ColorMap["prism_inverted"] = "prism_inverted";
    ColorMap["radar_coverage"] = "radar_coverage";
    ColorMap["radar_log"] = "radar_log";
    ColorMap["radar_reflectivity_segmented"] = "radar_reflectivity_segmented";
    ColorMap["radar_segmented"] = "radar_segmented";
    ColorMap["red_to_blue"] = "red_to_blue";
    ColorMap["red_yellow_green"] = "red_yellow_green";
    ColorMap["reds"] = "reds";
    ColorMap["reds_inverted"] = "reds_inverted";
    ColorMap["satellite"] = "satellite";
    ColorMap["satellite_fog"] = "satellite_fog";
    ColorMap["satellite_ir_clouds"] = "satellite_ir_clouds";
    ColorMap["satellite_ir_clouds_greys"] = "satellite_ir_clouds_greys";
    ColorMap["satellite_ir_colored"] = "satellite_ir_colored";
    ColorMap["satellite_ir_water_vapor"] = "satellite_ir_water_vapor";
    ColorMap["satellite_ndvi"] = "satellite_ndvi";
    ColorMap["seismic"] = "seismic";
    ColorMap["seismic_inverted"] = "seismic_inverted";
    ColorMap["snow_depth"] = "snow_depth";
    ColorMap["storm_warning"] = "storm_warning";
    ColorMap["sunshine_europe_segmented"] = "sunshine_europe_segmented";
    ColorMap["t_arabia"] = "t_arabia";
    ColorMap["t_europe"] = "t_europe";
    ColorMap["t_europe_segmented"] = "t_europe_segmented";
    ColorMap["t_global"] = "t_global";
    ColorMap["t_global_segmented"] = "t_global_segmented";
    ColorMap["theta_e_arabia"] = "theta_e_arabia";
    ColorMap["theta_e_global"] = "theta_e_global";
    ColorMap["theta_e_global_segmented"] = "theta_e_global_segmented";
    ColorMap["traffic_light"] = "traffic_light";
    ColorMap["traffic_light_inverted"] = "traffic_light_inverted";
    ColorMap["transparent_blue"] = "transparent_blue";
    ColorMap["transparent_green"] = "transparent_green";
    ColorMap["transparent_red"] = "transparent_red";
    ColorMap["tstorm_warning_europe_segmented"] = "tstorm_warning_europe_segmented";
    ColorMap["turbulence_ellrod3_segmented"] = "turbulence_ellrod3_segmented";
    ColorMap["turbulence_segmented"] = "turbulence_segmented";
    ColorMap["turbulence_segmented_inverted"] = "turbulence_segmented_inverted";
    ColorMap["ukmo_radar"] = "ukmo_radar";
    ColorMap["uv_index_europe_segmented"] = "uv_index_europe_segmented";
    ColorMap["viridis"] = "viridis";
    ColorMap["viridis_inverted"] = "viridis_inverted";
    ColorMap["visibility_airmet"] = "visibility_airmet";
    ColorMap["visibility_segmented"] = "visibility_segmented";
    ColorMap["vorticity_segmented"] = "vorticity_segmented";
    ColorMap["wave_height_segmented"] = "wave_height_segmented";
    ColorMap["wind_arabia"] = "wind_arabia";
    ColorMap["wind_arabia_beaufort"] = "wind_arabia_beaufort";
    ColorMap["wind_speed_europe_segmented"] = "wind_speed_europe_segmented";
    ColorMap["wind_warning_europe_segmented"] = "wind_warning_europe_segmented";
})(ColorMap || (ColorMap = {}));
const _segmentedColorMaps = {
    [ColorMap.air_quality_index]: true,
    [ColorMap.anomaly_temperature]: true,
    [ColorMap.binary_warning_segmented]: true,
    [ColorMap.blue_magenta]: false,
    [ColorMap.blue_to_red]: false,
    [ColorMap.blues]: false,
    [ColorMap.blues_inverted]: false,
    [ColorMap.cape]: false,
    [ColorMap.ceiling_height_segmented]: true, // TODO: 5 logical units, sampled 60 times
    [ColorMap.cloud_type]: true,
    [ColorMap.convective_categories]: true,
    [ColorMap.dust_concentration]: true,
    [ColorMap.dust_density]: true,
    [ColorMap.dwd_radar_5min]: true, // TODO: a few logical units, sampled 1000 times
    [ColorMap.dwd_warnings]: true,
    [ColorMap.edr_turbulence]: true,
    [ColorMap.fresh_snow_long_interval]: true,
    [ColorMap.fresh_snow_short_interval]: true, // TODO: fresh_snow_*_interval a few logical units, sampled 300 times
    [ColorMap.gray]: false,
    [ColorMap.gray_inverted]: false,
    [ColorMap.gray_transparent]: false,
    [ColorMap.gray_transparent_dark]: false,
    [ColorMap.greens_shifted]: false,
    [ColorMap.heavy_rain_warning_europe_segmented]: true,
    [ColorMap.incessant_rain_warning_europe_segmented]: true,
    [ColorMap.jet]: false,
    [ColorMap.jet_inverted]: false,
    [ColorMap.jet_segmented]: true,
    [ColorMap.jet_segmented_inverted]: true,
    [ColorMap.jetstream]: false,
    [ColorMap.land_usage]: true, // TODO: 2000 values with only a few logically occupied.
    [ColorMap.lifted_index_global]: false,
    [ColorMap.lifted_index_global_segmented]: true,
    [ColorMap.lightning_europe_transparent]: false,
    [ColorMap.magenta_blue]: false,
    [ColorMap.msg_h03b]: true, // TODO: 5 logical units sampled 288 times
    [ColorMap.negative_cold_index_segmented]: true,
    [ColorMap.negative_index_segmented]: true, // TODO: 5 logical units sampled 800 times
    [ColorMap.periodic]: false,
    [ColorMap.periodic_inverted]: false,
    [ColorMap.plasma]: false,
    [ColorMap.plasma_inverted]: false,
    [ColorMap.pollen_europe_segmented]: true,
    [ColorMap.pollen_grains_large]: true,
    [ColorMap.pollen_grains_medium]: true,
    [ColorMap.pollen_grains_small]: true, // TODO: pollen_grains_* have five logical units and are sampled 60/240/500 times
    [ColorMap.pollen_segmented]: true,
    [ColorMap.positive_index_segmented]: true, // TODO: a few logical units sampled 800 times
    [ColorMap.precip_europe_segmented]: true, // TODO: a few logical units sampled 400 times
    [ColorMap.precip_layer_europe_segmented]: true,
    [ColorMap.precip_layer_segmented]: true,
    [ColorMap.precip_segmented]: true,
    [ColorMap.precip_type_europe_segmented]: true,
    [ColorMap.precip_type_intensity_europe_segmented]: true, // TODO: a few of the percip types here are logically disjunkt legends and could be rendered as such
    [ColorMap.precip_type_intensity_usa_segmented]: true,
    [ColorMap.precip_type_intensity_segmented]: true,
    [ColorMap.precip_type_segmented]: true,
    [ColorMap.precip_usa_segmented]: true,
    [ColorMap.prism]: false,
    [ColorMap.prism_inverted]: false,
    [ColorMap.radar_coverage]: false,
    [ColorMap.radar_log]: true, // TODO: this has a few logical units, but is sampled 320 times
    [ColorMap.radar_reflectivity_segmented]: true,
    [ColorMap.radar_segmented]: true,
    [ColorMap.red_to_blue]: false,
    [ColorMap.red_yellow_green]: false,
    [ColorMap.reds]: false,
    [ColorMap.reds_inverted]: false,
    [ColorMap.satellite]: false,
    [ColorMap.satellite_fog]: false,
    [ColorMap.satellite_ir_colored]: false,
    [ColorMap.satellite_ir_clouds]: false,
    [ColorMap.satellite_ir_clouds_greys]: false,
    [ColorMap.satellite_ndvi]: true, // TODO: segmented into a few logical units, but sampled 200 times
    [ColorMap.satellite_ir_water_vapor]: false,
    [ColorMap.seismic]: false,
    [ColorMap.seismic_inverted]: false,
    [ColorMap.snow_depth]: true, // TODO: this has a few logical units, but is sampled 300 times
    [ColorMap.storm_warning]: true, // TODO: this has 4 logical units, but is sampled 120 times
    [ColorMap.sunshine_europe_segmented]: true, // TODO: this has 5 logical units, but is sampled 192 times
    [ColorMap.t_europe]: false,
    [ColorMap.t_europe_segmented]: true,
    [ColorMap.t_arabia]: false,
    [ColorMap.t_global]: false,
    [ColorMap.t_global_segmented]: true,
    [ColorMap.theta_e_arabia]: false,
    [ColorMap.theta_e_global]: false,
    [ColorMap.theta_e_global_segmented]: true,
    [ColorMap.traffic_light]: false,
    [ColorMap.traffic_light_inverted]: false,
    [ColorMap.transparent_blue]: false,
    [ColorMap.transparent_green]: false,
    [ColorMap.transparent_red]: false,
    [ColorMap.turbulence_ellrod3_segmented]: true,
    [ColorMap.tstorm_warning_europe_segmented]: true,
    [ColorMap.turbulence_segmented]: true, // TODO: this has 3 logical segments, but is sampled 60 times to give segments different heights. we currently do not consider this during legend labeling at all.
    [ColorMap.turbulence_segmented_inverted]: true,
    [ColorMap.ukmo_radar]: true,
    [ColorMap.uv_index_europe_segmented]: true,
    [ColorMap.viridis]: false,
    [ColorMap.viridis_inverted]: false,
    [ColorMap.visibility_segmented]: true,
    [ColorMap.wave_height_segmented]: true,
    [ColorMap.wind_speed_europe_segmented]: true,
    [ColorMap.wind_warning_europe_segmented]: true,
    [ColorMap.cin_segmented]: true,
    [ColorMap.ceiling_height_airmet]: false,
    [ColorMap.visibility_airmet]: false,
    [ColorMap.vorticity_segmented]: true,
    [ColorMap.wind_arabia]: false,
    [ColorMap.wind_arabia_beaufort]: false,
};
export const colormaps = enumValues(ColorMap);
export function isSegmented(colormap) {
    return _segmentedColorMaps[colormap];
}
/**
 * Chooses a default color map for some weather parameter
 */
export function defaultColorMap(parameter_) {
    const { narrowed_selection, parameter } = autofill(parameter_);
    const { unit } = narrowed_selection.fields;
    const name = parameter.name;
    return _defaultColorMap(name, unit);
}
export function defaultColorMapFromString(parameter) {
    const [name, unit] = parameter.split(":", 2);
    return _defaultColorMap(name, unit);
}
/**
 * This is word-by-word port of the backend function `get_default_wms_colormap`. Apply the following search-replace pairs
 * to turn the C++ syntax into typescript:
 *
 * ```
 * `starts_with(parameter,` to `parameter.startsWith(`
 * `.find(` to `.include(`
 * `!= string_view::npos` to ``
 * `!= string::npos` to ``
 * ```
 *
 * Last port was done against api commit 508a8c987782689256fafe96ebf40b135442bb06 on Tue Jun 22 05:58:09 2021
 */
function _defaultColorMap(name, unit) {
    const parameter = `${name}:${unit}`;
    // Find unit, if none is found we return Jet
    if (unit === "") {
        return ColorMap.jet;
    }
    if (parameter.includes("spread")) {
        return ColorMap.jet;
    }
    if (parameter.startsWith("anomaly_t_")) {
        return ColorMap.anomaly_temperature;
    }
    // Satellite channel covering infrared band
    if (parameter.startsWith("sat_ir_104") || parameter.startsWith("sat_ir_108")) {
        // Currently only available for K and C units
        if (unit === "K" || unit === "C") {
            return ColorMap.satellite_ir_colored;
        }
    }
    if (parameter.startsWith("sat_ir_062")) {
        if (unit === "K" || unit === "C") {
            return ColorMap.satellite_ir_water_vapor;
        }
    }
    if (unit === "C" || unit === "K" || unit === "F") {
        if (parameter.startsWith("lifted_index")) {
            return ColorMap.lifted_index_global;
        }
        if (parameter.startsWith("theta_e")) {
            return ColorMap.theta_e_global;
        }
        if (parameter.startsWith("sat_")) {
            // satellite brightness temperature
            return ColorMap.gray_inverted;
        }
        return ColorMap.t_europe;
    }
    if (unit === "Wm2umsr") {
        // satellite radiance
        return ColorMap.gray;
    }
    /*
   // Velocity: maybe a perceptively linear colormap?
   if (unit === "ms" || unit === "kmh" || unit === "kn")
   {
       return ColorMap.Jet;
   }
   */
    // Pressure
    if (unit === "hPa" || unit === "Pa" || unit === "psi") {
        return ColorMap.viridis;
    }
    // Probability & percentage
    if (unit === "p" || unit === "octas") {
        if (parameter.startsWith("relative_humidity")) {
            return ColorMap.greens_shifted;
        }
        if (parameter.includes("cloud_cover")) {
            return ColorMap.gray_transparent_dark;
        }
        if (parameter.startsWith("zombie")) {
            if (parameter.includes("survival")) {
                return ColorMap.traffic_light;
            }
            return ColorMap.dwd_warnings;
        }
        if (parameter.startsWith("sat_")) {
            // satellite reflectance
            return ColorMap.gray;
        }
        // Otherwise jet, as the rest are probabilities and jet seems to be suitable for that
        return ColorMap.jet;
    }
    // Directions
    if (unit === "d" && parameter.includes("_dir")) {
        return ColorMap.periodic;
    }
    // Sunshine duration
    if (unit === "h" || unit === "min") {
        if (parameter.startsWith("covid")) {
            return ColorMap.blue_to_red;
        }
        return ColorMap.plasma;
    }
    // Distances
    if (unit === "m" || unit === "km" || unit === "ft" || unit === "hft") {
        if (parameter.startsWith("visibility") || parameter.startsWith("runway_visual_range")) {
            return ColorMap.visibility_segmented;
        }
        if (parameter.startsWith("ceiling_height_agl") || parameter.startsWith("cloud_base_agl")) {
            return ColorMap.ceiling_height_segmented;
        }
        return ColorMap.jet;
    }
    if (unit === "nmi") {
        if (parameter.startsWith("visibility")) {
            return ColorMap.visibility_segmented;
        }
    }
    // Precip
    if (parameter.startsWith("precip_") || parameter.startsWith("calibrated_precip_")) {
        return ColorMap.precip_segmented;
    }
    // mm
    if (unit === "mm") {
        if (parameter.startsWith("evaporation_")) {
            return ColorMap.blues;
        }
        return ColorMap.jet;
    }
    // Snow & tides: cm
    if (unit === "cm") {
        if (parameter.startsWith("fresh_snow")) {
            const get_interval_hour_from_parameter = () => {
                if (parameter.includes("_1h")) {
                    return 1;
                }
                if (parameter.includes("_2h")) {
                    return 2;
                }
                if (parameter.includes("_3h")) {
                    return 3;
                }
                if (parameter.includes("_6h")) {
                    return 6;
                }
                if (parameter.includes("_12h")) {
                    return 12;
                }
                if (parameter.includes("_24h")) {
                    return 24;
                }
                if (parameter.includes("_48h")) {
                    return 48;
                }
                return -1;
            };
            const N = get_interval_hour_from_parameter();
            if (N < 6) {
                return ColorMap.fresh_snow_short_interval;
            }
            return ColorMap.fresh_snow_long_interval;
        }
        if (parameter.startsWith("snow_depth")) {
            return ColorMap.snow_depth;
        }
        if (parameter.startsWith("tidal_amplitude") || parameter.startsWith("surge_amplitude")) {
            return ColorMap.seismic;
        }
        return ColorMap.jet;
    }
    // Radiation
    if (unit === "W" || unit === "Ws" || unit === "J" || unit === "Wh") {
        return ColorMap.plasma;
    }
    // Indices
    if (unit === "idx") {
        if (parameter.startsWith("dew_or_rime")) {
            return ColorMap.blue_to_red;
        }
        if (parameter.startsWith("freezing_rain")) {
            return ColorMap.reds;
        }
        if (parameter.startsWith("warnings_active")) {
            return ColorMap.binary_warning_segmented;
        }
        if (parameter.startsWith("convective_categories")) {
            return ColorMap.convective_categories;
        }
        if (parameter.includes("cloud_layer")) {
            return ColorMap.gray;
        }
        if (parameter.startsWith("sat_")) {
            if (parameter.includes("rgb", 4)) {
                return ColorMap.satellite;
            }
            if (parameter.includes("fog", 4)) {
                return ColorMap.satellite_fog;
            }
            if (parameter.includes("ndvi", 4)) {
                return ColorMap.satellite_ndvi;
            }
            if (parameter.includes("cloud_type", 4)) {
                return ColorMap.cloud_type;
            }
            // for longer wavelengths in IR range, gray inverted is better than gray (it is what is commonly used)
            if (parameter.includes("ir_039", 4) || parameter.includes("ir_108", 4)) {
                return ColorMap.gray_inverted;
            }
            // Sat Cb storm warning
            if (parameter.includes("storm_", 4)) {
                if (parameter.includes("severity", 10)) {
                    return ColorMap.reds;
                }
                if (parameter.includes("warning", 10)) {
                    return ColorMap.storm_warning;
                }
            }
            // remaining parameters are the individual channels
            else {
                return ColorMap.gray;
            }
        }
        else if (parameter.startsWith("is_in_shadow")) {
            return ColorMap.jet_inverted;
        }
        else if (parameter.startsWith("is_not_in_shadow")) {
            return ColorMap.jet;
        }
        else if (parameter.startsWith("icing_potential")) {
            return ColorMap.reds;
        }
        else if (parameter.startsWith("land_usage")) {
            return ColorMap.land_usage;
        }
        else if (parameter.startsWith("precip_layer")) {
            return ColorMap.precip_layer_segmented;
        }
        else if (parameter.startsWith("precip_type_intensity")) {
            return ColorMap.precip_type_intensity_segmented;
        }
        else if (parameter.startsWith("precip_type")) {
            return ColorMap.precip_type_segmented;
        } //ORDER IMPORTANT
        else if (parameter.startsWith("sld_potential")) {
            return ColorMap.reds;
        }
        else if (parameter.includes("pollen")) {
            return ColorMap.pollen_segmented;
        }
        else if (parameter.includes("_sot")) {
            return ColorMap.blue_to_red;
        }
        else if (parameter.includes("_efi")) {
            return ColorMap.blue_to_red;
        }
        else if (parameter.includes("warning")) {
            return ColorMap.storm_warning;
        }
        else if (parameter.includes("soaring_index")) {
            return ColorMap.jet_segmented;
        }
        else if (parameter.startsWith("richardson")) {
            return ColorMap.turbulence_segmented;
        }
        else if (parameter.startsWith("turbulence_cape")) {
            return ColorMap.turbulence_segmented_inverted;
        }
        else if (parameter.startsWith("aerodrome_approach")) {
            return ColorMap.traffic_light_inverted;
        }
        else if (parameter.startsWith("soil_moisture_index")) {
            return ColorMap.jet_inverted;
        }
        else {
            // Default colormap for ones that don’t apply the conditions above.
            return ColorMap.jet;
        }
    }
    // pollen grain
    if (unit === "grainsm3") {
        if (parameter.startsWith("olive_pollen") || parameter.startsWith("ragweed_pollen")) {
            return ColorMap.pollen_grains_small;
        }
        if (parameter.startsWith("grass_pollen")) {
            return ColorMap.pollen_grains_medium;
        } // birch_pollen, pollen
        return ColorMap.pollen_grains_large;
    }
    // Turbulence: 1/s^2
    if (unit === "s2") {
        if (parameter.startsWith("turbulence_ellrod")) {
            return ColorMap.turbulence_ellrod3_segmented;
        }
    }
    // Lightnings
    if (unit === "x" && parameter.startsWith("lightning_strikes")) {
        return ColorMap.plasma;
    }
    // Convective inhibition (CIN)
    // unit isn't important, because there is only one available
    if (parameter.startsWith("cin")) {
        return ColorMap.cin_segmented;
    }
    // Convective available potential energy
    if (parameter.startsWith("cape")) {
        return ColorMap.cape;
    }
    // Radar reflectivity
    if (parameter.startsWith("reflectivity")) {
        return ColorMap.radar_reflectivity_segmented;
    }
    // Eddy Dissipation Rate - Indicator of turbulance
    if (parameter.startsWith("edr")) {
        return ColorMap.edr_turbulence;
    }
    if (parameter.startsWith("vorticity_")) {
        return ColorMap.vorticity_segmented;
    }
    // dust_0p03um_0p55um, dust_0p55um_0p9um, dust_0p9um_20um, tc_dust
    if (parameter.startsWith("dust_0p") || parameter.startsWith("tc_dust")) {
        return ColorMap.dust_concentration;
    }
    // Default to jet
    return ColorMap.jet;
}
//# sourceMappingURL=ColorMap.js.map